import React, { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";

// TABLE
import { laporanJurnalTable } from "./laporanJurnalTable";
import jsPDF from "jspdf";
import "jspdf-autotable";

// API
import { getLaporanJurnalByKodeAkun } from "./api/laporanJurnalAPI";
import { getDropdownKodeAkun } from "views/admin/masterData/kodeAkun/api/kodeAkunAPI";

// Components
import CardTableJurnalUmum from "components/Cards/CardTableJurnalUmum";
import { CurrencyFormat } from "views/helpers/CurrencyFormat";

export default function LaporanJurnal() {
  // const [active, setActive] = useState(false);
  const tanggalSaatIni = new Date().toISOString().slice(0, 10);
  const tanggalAwalBulan = tanggalSaatIni.slice(0, 7) + "-01";

  const [formData, setFormData] = useState({
    tanggal_awal: tanggalAwalBulan,
    tanggal_akhir: tanggalSaatIni,
  });

  const [dataTable, setDataTable] = useState([]);
  const [dataInput, setDataInput] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [errors, setErrors] = useState(null);

  const [isExportable, setIsExportable] = useState(false);

  // Select-Option Data
  const [dropdownAkun, setDropdownAkun] = useState([]);

  // Loading
  useEffect(() => {
    if (isLoading === true) {
      toast.loading("Data Diproses...");
    }
  }, [isLoading]);

  // Handle when Page Change
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  // Set Inputed Data to Form
  const setData = (key, value) => {
    console.log(formData);
    return setFormData({ ...formData, [key]: value });
  };

  // Load Dropdown Kode Akun
  useEffect(() => {
    setIsLoading(true);

    getDropdownKodeAkun()
      .then((response) => {
        setDropdownAkun(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownAkun([]);
    };
  }, []);

  const handleGetLaporanJurnal = (e) => {
    e.preventDefault();
    setIsLoading(true);

    getLaporanJurnalByKodeAkun(formData)
      .then((response) => setResult(response))
      .catch((err) => setErrors(err))
      .finally(endSubmitProcess());
  };

  // Handle when Submit Process End
  const endSubmitProcess = () => {
    setIsLoading(false);
  };

  // Check if Request Failed
  useEffect(() => {
    if (errors !== null) {
      toast.error(errors.message);
    }
  }, [errors]);

  // Check if Request Success
  useEffect(() => {
    if (result !== null) {
      if (result.data.success === true) {
        toast.success(result.data.message);
        setDataTable(result.data.data.dataTransaksi);
        setDataInput(result.data.data.dataInput);
        setIsExportable(true);
        setPageNumber(0);
        // setActive(true)
      } else {
        setIsExportable(false);
        let numericArray = [];
        for (let err in result.data.errors) {
          numericArray.push(result.data.errors[err]);
        }

        if (numericArray.length > 0) {
          toast.error(numericArray[0]);
        }
      }
    }
    setResult(null);
  }, [result]);

  const exportPDF = () => {
    const unit = "pt";
    const size = "A4";
    const orientation = "landscape";

    const marginLeft = 20;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = `Jurnal Umum (${dataInput.tanggal_awal} s/d ${dataInput.tanggal_akhir})`;
    const headers = [
      [
        "Nomor Transaksi",
        "Tanggal Transaksi",
        "Nama Anggaran",
        "Debet",
        "Kredit",
      ],
    ];

    const data = dataTable.map((elt) => [
      elt.nomor_transaksi,
      elt.tanggal_transaksi,
      elt.nama_anggaran,
      elt.debet !== null ? CurrencyFormat(elt.debet) : "",
      elt.kredit !== null ? CurrencyFormat(elt.kredit) : "",
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("jurnalUmum.pdf");
  };

  return (
    <div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <Toaster />
          <CardTableJurnalUmum
            tableTitle="Jurnal Umum"
            cols={laporanJurnalTable()}
            data={dataTable}
            pageNumber={pageNumber}
            changePage={changePage}
            handleSubmit={handleGetLaporanJurnal}
            setData={setData}
            exportPDF={exportPDF}
            isExportable={isExportable}
            kodeAkunDropdown={dropdownAkun}
          />
        </div>
      </div>
    </div>
  );
}
